import { render, staticRenderFns } from "./Rule_TK-2cards.vue?vue&type=template&id=269ed1bc&"
import script from "./Rule_TK-2cards.vue?vue&type=script&lang=js&"
export * from "./Rule_TK-2cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports